import { z } from 'zod';
import { AuditActionSchema } from '../lib/enums';
import { paginated, zEmail, zIsoDateTime, zSha256Hex, zUuid } from './common';
// ---------------------------------------------------------------- audit trail
/** Append-only audit event. `id` is a bigserial — serialized as a string. */
export const AuditEventSchema = z.object({
    id: z.string().regex(/^\d+$/),
    action: AuditActionSchema,
    actorUserId: zUuid.nullable(),
    actorCompanyId: zUuid.nullable(),
    /** Set when the actor was a public token (proposal/invite flows). */
    publicTokenId: zUuid.nullable(),
    entityType: z.string().max(64).nullable(),
    entityId: zUuid.nullable(),
    beforeHash: zSha256Hex.nullable(),
    afterHash: zSha256Hex.nullable(),
    ip: z.string().max(64).nullable(),
    userAgent: z.string().max(500).nullable(),
    metadata: z.record(z.unknown()),
    createdAt: zIsoDateTime,
});
export const AuditQuerySchema = z.object({
    action: z.string().max(120).optional(),
    entityType: z.string().max(64).optional(),
    entityId: zUuid.optional(),
    actorUserId: zUuid.optional(),
    from: zIsoDateTime.optional(),
    to: zIsoDateTime.optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
    offset: z.coerce.number().int().min(0).default(0),
});
export const AuditEventsResponseSchema = paginated(AuditEventSchema);
// --------------------------------------------------------------------- outbox
/** Local email capture — nothing is ever actually sent in this build. */
export const OutboxEmailSchema = z.object({
    id: zUuid,
    toEmail: zEmail,
    subject: z.string(),
    bodyHtml: z.string().nullable(),
    bodyText: z.string().nullable(),
    templateKey: z.string().max(64),
    payload: z.record(z.unknown()),
    createdAt: zIsoDateTime,
});
export const OutboxEmailSummarySchema = OutboxEmailSchema.omit({
    bodyHtml: true,
    bodyText: true,
    payload: true,
});
export const OutboxListResponseSchema = z.array(OutboxEmailSummarySchema);
//# sourceMappingURL=audit.js.map